var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImagen2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "142.000000pt",
    height: "115.000000pt",
    viewBox: "0 0 142.000000 115.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,115.000000) scale(0.100000,-0.100000)",
    fill: "#a7b1c2",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M380 881 c-207 -66 -305 -101 -305 -111 0 -9 35 -25 97 -44 l96 -31 -19 -37 c-11 -21 -22 -59 -26 -85 -3 -27 -14 -59 -25 -72 -22 -29 -23 -59 -3 -89 14 -19 14 -33 0 -132 -8 -61 -15 -117 -15 -125 0 -12 15 -15 70 -15 55 0 70 3 70 15 0 8 -7 64 -15 125 -14 99 -14 113 0 132 19 28 19 59 0 84 -18 23 -19 54 -3 105 23 77 24 77 225 14 l178 -57 305 96 c167 53 309 101 314 106 7 7 6 14 0 20 -12 12 -605 201 -626 199 -7 -1 -150 -45 -318 -98z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360 486 l0 -105 33 -25 c17 -13 61 -35 97 -47 57 -20 84 -23 215 -23 131 0 158 3 215 23 36 12 80 34 98 47 l32 25 0 105 c0 59 -4 104 -10 104 -5 0 -80 -22 -166 -50 -86 -27 -162 -50 -168 -50 -7 0 -84 23 -171 50 -87 28 -163 50 -167 50 -4 0 -8 -47 -8 -104z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagen2);
export default __webpack_public_path__ + "static/media/Imagen2.f738e7ea76b2cd78f92f2bc0e59a8d2e.svg";
export { ForwardRef as ReactComponent };